import React, { useEffect } from 'react'

const PerformanceOptimizer = () => {
  useEffect(() => {
    // Lazy loading için Intersection Observer
    const lazyImages = document.querySelectorAll('img[data-src]')
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target
          img.src = img.dataset.src
          img.classList.remove('lazy')
          observer.unobserve(img)
        }
      })
    })

    lazyImages.forEach(img => imageObserver.observe(img))

    // Preload kritik kaynaklar
    const preloadCriticalResources = () => {
      // Logo preload
      const logoLink = document.createElement('link')
      logoLink.rel = 'preload'
      logoLink.as = 'image'
      logoLink.href = '/logo.png'
      document.head.appendChild(logoLink)

      // Font preload
      const fontLink = document.createElement('link')
      fontLink.rel = 'preload'
      fontLink.as = 'font'
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap'
      fontLink.crossOrigin = 'anonymous'
      document.head.appendChild(fontLink)
    }

    // Service Worker registration
    const registerServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.register('/sw.js')
          console.log('Service Worker registered:', registration)
        } catch (error) {
          console.log('Service Worker registration failed:', error)
        }
      }
    }

    // Performance monitoring
    const monitorPerformance = () => {
      if ('performance' in window) {
        window.addEventListener('load', () => {
          setTimeout(() => {
            const perfData = performance.getEntriesByType('navigation')[0]
            const loadTime = perfData.loadEventEnd - perfData.loadEventStart
            
            console.log('Page Load Time:', loadTime + 'ms')
            
            // Core Web Vitals monitoring
            if ('web-vital' in window) {
              // LCP (Largest Contentful Paint)
              new PerformanceObserver((list) => {
                for (const entry of list.getEntries()) {
                  console.log('LCP:', entry.startTime + 'ms')
                }
              }).observe({ entryTypes: ['largest-contentful-paint'] })

              // FID (First Input Delay)
              new PerformanceObserver((list) => {
                for (const entry of list.getEntries()) {
                  console.log('FID:', entry.processingStart - entry.startTime + 'ms')
                }
              }).observe({ entryTypes: ['first-input'] })

              // CLS (Cumulative Layout Shift)
              new PerformanceObserver((list) => {
                let cls = 0
                for (const entry of list.getEntries()) {
                  if (!entry.hadRecentInput) {
                    cls += entry.value
                  }
                }
                console.log('CLS:', cls)
              }).observe({ entryTypes: ['layout-shift'] })
            }
          }, 0)
        })
      }
    }

    // Initialize optimizations
    preloadCriticalResources()
    registerServiceWorker()
    monitorPerformance()

    // Cleanup
    return () => {
      imageObserver.disconnect()
    }
  }, [])

  return null
}

export default PerformanceOptimizer
